import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const ParcelTypesLetterbox: FC<SvgIconProps> = ({ viewBox = '0 0 254 170', ...props }) => (
  <SvgIcon viewBox={viewBox} fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
    <path d="M105.448 103.268L206.022 85.1453L148.552 61.5804L47.9778 79.3334L105.448 103.268Z" fill="#FDDE84" />
    <path opacity="0.4" d="M80.134 92.735L179.493 74.2617L169.333 70.125L70.5555 88.74L80.134 92.735Z" fill="#AA7B33" />
    <path d="M105.449 103.268V112.884L47.9778 88.9495V79.3334L105.449 103.268Z" fill="#C39000" />
    <path d="M105.448 103.268V112.884L206.022 94.3916V85.1453L105.448 103.268Z" fill="#FCCE09" />
    <path opacity="0.4" d="M80.134 92.735V102.312L70.5555 98.3366V88.7077L80.134 92.735Z" fill="#AA7B33" />
  </SvgIcon>
)
